import React, {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Input, message, Form, Select } from "antd";
import styles from "../index.module.less";
import _lodash, { get } from "lodash";
import { ajaxApiGet } from "../../../../server/index";
import common from "@/public/common";
import { getParmUrl } from "@/public/utils";
import OxygenPermeabilityModal from "./oxygenPermeabilityModal";
import OxygenPermeabilityCoefficient from "./oxygenPermeabilityCoefficientModal";
const LucencyForm = forwardRef(({ addData, changeData, getCurrent }, ref) => {
  const [initData, setInitData] = useState([]);
  const [form] = Form.useForm();

  const [oxygenPermeabilityModalVisabel, setOxygenPermeabilityModalVisabel] =
    useState(false);
  const [oxygenCountHPa, setOxygenCountHPa] = useState(null);
  const [oxygenCountMmhg, setOxygenCountMmhg] = useState(null);

  const [
    oxygenPermeabilityCoefficientModalVisabel,
    setOxygenPermeabilityCoefficientModalVisabel,
  ] = useState(false);
  const [oxygenMmhg, setOxygenMmhg] = useState(null);
  const [contactOxygen, setContactOxygen] = useState(null);

  //存入缓存并保存state
  function saveSession() {
    let data = { ...form.getFieldsValue(), color: "无色" };
    const addDataClone = _lodash.cloneDeep(addData);
    addDataClone.extend_color_properties = [data];
    changeData(addDataClone);
    sessionStorage.setItem("addData", JSON.stringify(addDataClone));
  }
  //初始化获取扩展数据
  function getCurrencyList() {
    const session = JSON.parse(
      sessionStorage.getItem("addData")
    ).extend_color_properties; //缓存
    ajaxApiGet({
      url:
        common.scpUrl +
        `item/category-attrs?category=${getParmUrl("categoryid")}`,
    }).then((res) => {
      if (res.data.code === 200) {
        //过滤更换周期和是否彩色选项
        res.data.data.extra_attrs = res.data.data.extra_attrs.filter(
          (item) =>
            item.english_name !== "ContactsType" &&
            item.english_name !== "ContactDiscardCycle" &&
            item.english_name !== "ColoredDiameter"
        );
        //大写换小写和后端保持一致
        res.data.data.extra_attrs.map((item) => {
          item.english_name = item.english_name.toLowerCase();
        });
        //保存基础数据
        setInitData(res.data.data.extra_attrs);
        //如果有缓存，则使用缓存数据
        if (session) {
          form.setFieldsValue(session[0]);
        }
      }
    });
  }

  //表单提交
  function formSebmit() {
    form.submit();
  }
  //下一步
  function onFinish() {
    saveSession();
    getCurrent(1);
  }
  //表单校验
  function onFinishFailed(e) {
    message.warn(e.errorFields[0].errors[0] || "");
  }
  //暴露方法和数据
  useImperativeHandle(
    ref,
    () => {
      return { formSebmit };
    },
    []
  );
  useEffect(() => {
    getCurrencyList();
    //初始化表单写入
  }, []);

  // 修改透氧量
  const oxygenPermeabilityModalOk = (info) => {
    try {
      let mmhg =
        info.mmhg === 0
          ? "0.00Dk/t单位(mmHg)"
          : info.mmhg
          ? Number(info.mmhg || 0).toFixed(2) + "Dk/t单位(mmHg)"
          : null;
      let hpa =
        info.hpa === 0
          ? "0.00Dk/t单位(hPa)"
          : info.hpa
          ? Number(info.hpa || 0).toFixed(2) + "Dk/t单位(hPa)"
          : null;
      form.setFieldsValue({
        oxygencount_mmhg: mmhg,
        oxygencount_hpa: hpa,
      });
      setOxygenPermeabilityModalVisabel(false);
    } catch (err) {
      console.log(err);
    }
  };

  // 修改透氧系数
  const oxygenPermeabilityCoefficientModalOk = (info) => {
    let mmhg =
      info.mmhg === 0
        ? "0.00Dk单位(mmHg)"
        : info.mmhg
        ? Number(info.mmhg || 0).toFixed(2) + "Dk单位(mmHg)"
        : null;
    let hpa =
      info.hpa === 0
        ? "0.00Dk单位(hPa)"
        : info.hpa
        ? Number(info.hpa || 0).toFixed(2) + "Dk单位(hPa)"
        : null;
    form.setFieldsValue({
      oxygen_mmhg: mmhg,
      contactoxygen: hpa,
    });
    setOxygenPermeabilityCoefficientModalVisabel(false);
  };

  const openOxygenModal = (info) => {
    let englishName = info.english_name;
    if (["contactoxygen", "oxygen_mmhg"].includes(englishName)) {
      // 打开透氧系数弹窗
      setOxygenMmhg(
        get((form.getFieldValue("oxygen_mmhg") || "").split("Dk单位"), "[0]") ||
          null
      );
      setContactOxygen(
        get(
          (form.getFieldValue("contactoxygen") || "").split("Dk单位"),
          "[0]"
        ) || null
      );
      setOxygenPermeabilityCoefficientModalVisabel(true);
    } else if (["oxygencount_hpa", "oxygencount_mmhg"].includes(englishName)) {
      // 打开透氧量弹窗
      setOxygenCountMmhg(
        get(
          (form.getFieldValue("oxygencount_mmhg") || "").split("Dk/t"),
          "[0]"
        ) || null
      );
      setOxygenCountHPa(
        get(
          (form.getFieldValue("oxygencount_hpa") || "").split("Dk/t"),
          "[0]"
        ) || null
      );
      setOxygenPermeabilityModalVisabel(true);
    }
  };
  const restrictTwoNumber = (inputValue, record) => {
    if (!inputValue) {
      return false; // 空输入返回 true
    } else {
      const numPattern = /[\d.]+/; // 匹配数字和小数点
      const numberMatch = inputValue.match(numPattern);
      if (numberMatch) {
        const number = numberMatch[0];
        if (
          [
            "contactarc",
            "contactdiameter",
            "oxygen_mmhg",
            "contactoxygen",
            "oxygencount_hpa",
            "oxygencount_mmhg",
          ].includes(record.property_key)
        ) {
          return !(
            Number.isInteger(number) ||
            number.split(".")[1].length === 2
          ); // 不符合则返回 true
        } else if (
          ["contactthickness", "contactrefraction"].includes(
            record.property_key
          )
        ) {
          return !(
            Number.isInteger(number) ||
            number.split(".")[1].length === 3
          ); // 不符合则返回 true
        }
      } else {
        return false;
      }
    }
  };
  const validateUsername = (key, value) => {
    if (
      [
        "contactarc",
        "contactdiameter",
        "oxygen_mmhg",
        "contactoxygen",
        "oxygencount_hpa",
        "oxygencount_mmhg",
      ].includes(key.field) &&
      restrictTwoNumber(value, {
        property_key: key.field,
      })
    ) {
      return Promise.reject(new Error("数字部分请保留2位小数"));
    } else if (
      ["contactthickness", "contactrefraction"].includes(key.field) &&
      restrictTwoNumber(value, {
        property_key: key.field,
      })
    ) {
      return Promise.reject(new Error("数字部分请保留3位小数"));
    }
    return Promise.resolve();
  };
  return (
    <div>
      <div className={styles.total_title}>
        <span className={styles.titles}>扩展属性</span>
      </div>
      <Form
        layout="inline"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ paddingLeft: "13%" }}
        onChange={saveSession}
        className={styles.public_info}
        labelCol={{
          style: { width: "160px" },
        }}
      >
        {initData.map((ele) => (
          <div key={ele.english_name} className={styles.publicsection}>
            {ele.edit_method == "text" && (
              <Form.Item
                labelAlign="right"
                name={[ele.english_name]}
                rules={[
                  {
                    required: ele.is_required,
                    message: `请输入${ele.property_name}`,
                  },
                  { validator: validateUsername },
                ]}
                label={ele.property_name}
                className={styles.main_item}
              >
                <Input
                  onClick={() => {
                    openOxygenModal(ele);
                  }}
                  readOnly={[
                    "oxygen_mmhg",
                    "contactoxygen",
                    "oxygencount_mmhg",
                    "oxygencount_hpa",
                  ].includes(ele.english_name)}
                  style={{ width: "244px" }}
                  placeholder="请输入"
                />
              </Form.Item>
            )}
            {(ele.edit_method == "single" || ele.edit_method == "multiple") && (
              <Form.Item
                name={[ele.english_name]}
                rules={[
                  {
                    required: ele.is_required,
                    message: `请输入${ele.property_name}`,
                  },
                ]}
                className={styles.main_item}
                label={ele.property_name}
              >
                <Select
                  allowClear
                  fieldNames={{
                    label: "dict_name",
                    value: "dict_key",
                  }}
                  placeholder="请选择"
                  options={ele.value_list}
                  mode={ele.edit_method === "multiple" && "multiple"}
                  style={{ width: "244px" }}
                />
              </Form.Item>
            )}
          </div>
        ))}
      </Form>
      {
        // 修改透氧量弹窗
        oxygenPermeabilityModalVisabel && (
          <OxygenPermeabilityModal
            onCancel={() => {
              setOxygenPermeabilityModalVisabel(false);
            }}
            oxygenCountHPa={oxygenCountHPa}
            oxygenCountMmhg={oxygenCountMmhg}
            open={oxygenPermeabilityModalVisabel}
            onOk={oxygenPermeabilityModalOk}
          />
        )
      }
      {
        // 修改透氧系数弹窗
        oxygenPermeabilityCoefficientModalVisabel && (
          <OxygenPermeabilityCoefficient
            onCancel={() => {
              setOxygenPermeabilityCoefficientModalVisabel(false);
            }}
            contactOxygen={contactOxygen}
            oxygenMmhg={oxygenMmhg}
            open={oxygenPermeabilityCoefficientModalVisabel}
            onOk={oxygenPermeabilityCoefficientModalOk}
          />
        )
      }
    </div>
  );
});

export default LucencyForm;



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/components/LucencyForm.jsx